import { Grid, Spinner } from "@chakra-ui/react";
import { NavigatingLoadIndicator } from "../NavigatingLoadIndicator/NavigatingLoadIndicator";

export const PageLoader = () => {
	return (
		<Grid bgColor="shade.100" position="fixed" inset={0} placeItems="center" zIndex="100000">
			<NavigatingLoadIndicator />
			<Spinner size="xl" />
		</Grid>
	);
};
